import { GUID } from '@utils/AppConstants';

export enum PopupType {
    Information = 1,
    Warning = 2,
    Alert = 3,
}

export interface ActivePopupModel {
    Guid: GUID;
    Title: string;
    HtmlContent: string;
    PopupType: string;
    PopupTypeId: PopupType;
}

export interface PopupDetailModel {
    Guid: GUID;
    Title: string;
    HtmlContent: string;
    PopupTypeId: PopupType;
    DateFrom: string;
    DateTo: string;
    IsActive: boolean;
    TargetLabId: number;
    TargetDivisionId: number;
}

export interface PopupListItemModel {
    Guid: GUID;
    Title: string;
    PopupType: string;
    PopupTypeId: PopupType;
    DateFrom: string;
    DateTo: string;
    IsActive: boolean;
    TargetLabName: string;
    TargetDivisionName: string;
    CreatedOnUtc: string;
    CreatedBy: string;
}

export interface SavePopupRequest {
    Title: string;
    HtmlContent: string;
    PopupType: PopupType;
    DateFrom: string;
    DateTo: string;
    IsActive: boolean;
    TargetLabId: number;
    TargetDivisionId: number;
}

export interface SetActiveRequest {
    IsActive: boolean;
}

